import quillRegistry from "../quill_registry"
import Delta from "quill-delta"

// Button attribute to track click listener initialization
const replyBtnInit = "data-reply-button-init"

export const ActivityFeed = {
  mounted() {
    updateLinksToOpenInNewTab(this.el)
    this.handleEvent("highlight:new_activity_feed_item", (params) => {
      let activityFeedItem =
        document.getElementById(params.activity_item_id) ||
        document.getElementById(`activity-feed-item-${params.activity_id}`) ||
        document.getElementById(
          `activity-feed-item-${params.activity_id}-account`,
        )

      scrollAndHighlight(activityFeedItem)
    })

    this.handleEvent("highlight:comment", (params) => {
      let commentItem = document.getElementById(
        `comment-id-${params.comment_id}`,
      )

      if (commentItem) {
        scrollAndHighlight(commentItem)
      }
    })

    this.handleEvent("fill-reply-info", (params) => {
      const button = this.el.querySelector(
        `[data-activity-reply][data-comment-id="${params.comment_id}"]`,
      )

      if (button) button.click()
    })

    this.updated()

    this.el.addEventListener("click", (event) => {
      const btn = event.target.closest(
        ".activity-comment-control-button-edit, [data-activity-edit]",
      )
      if (btn) {
        this.pushEventTo(
          btn.closest(".activity-feed"),
          "open-object-for-editing",
          {
            activity_alias: btn.dataset.activityAlias,
          },
        )
      }
    })
  },
  updated() {
    updateLinksToOpenInNewTab(this.el)
    initReplyButtons(
      // fetch all uninitialized reply buttons
      this.el.querySelectorAll(`[data-activity-reply]:not([${replyBtnInit}])`),
    )
  },
}

function updateLinksToOpenInNewTab(container) {
  container.querySelectorAll("a").forEach((link) => {
    link.setAttribute("target", "_new")
  })
}

function initReplyButtons(buttons) {
  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const composer = replyComposerFor(button)
      if (!composer) return

      const { elm, in_reply_to_input } = composer
      // Set before the editor changes: writing the mention pushes the form's
      // change event, and that payload must already carry the reply-to id.
      in_reply_to_input.value = button.dataset.commentId
      scrollAndHighlight(elm)
      const editor = quillRegistry.get(elm.id)
      editor.setContents(
        new Delta([
          {
            insert: {
              mention: { value: button.dataset.fullName, denotationChar: "@" },
            },
          },
        ]),
      )
      editor.setSelection({ index: 2, length: 0 })
      editor.focus()
    })

    // mark button as initialized
    button.setAttribute(replyBtnInit, "true")
  })
}

// The composer that owns this feed: the nearest ancestor holding a reply-to
// input. The Account and Deal modals wrap it differently, so no wrapper class
// is assumed.
function replyComposerFor(button) {
  for (let el = button.parentElement; el; el = el.parentElement) {
    const in_reply_to_input = el.querySelector(
      'input[name="comment_add[in_reply_to_id]"]',
    )

    if (in_reply_to_input) {
      const elm = in_reply_to_input.form?.querySelector(
        '[role="rich-text-editor"]',
      )
      return elm ? { elm, in_reply_to_input } : null
    }
  }

  return null
}

function scrollAndHighlight(el) {
  el.scrollIntoView({ block: "nearest", behavior: "smooth" })
  el.classList.add("highlighted-without-border")
  el.focus()
}
